
import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { WorksheetFormFields } from "./WorksheetFormFields";
import { worksheetFormSchema, WorksheetFormValues } from "./worksheetFormSchema";

interface WorksheetCreateDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSave: (data: WorksheetFormValues) => void;
}

export const WorksheetCreateDialog: React.FC<WorksheetCreateDialogProps> = ({
  isOpen,
  setIsOpen,
  onSave
}) => {
  const form = useForm<WorksheetFormValues>({
    resolver: zodResolver(worksheetFormSchema),
    defaultValues: {
      name: "",
      subject: "",
      grade_level: "",
      semester: "",
      fs_name: "",
      document_urls: [], // Initialize as an empty array to match the schema
      status: ""
    }
  });

  const handleSubmit = (data: WorksheetFormValues) => {
    onSave(data);
    form.reset();
  };

  const handleClose = () => {
    setIsOpen(false);
    form.reset();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[550px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>เพิ่มชีทใหม่</DialogTitle>
          <DialogDescription>
            กรอกข้อมูลเพื่อเพิ่มชีทการสอนใหม่เข้าสู่ระบบ
          </DialogDescription>
        </DialogHeader>
        
        <Form {...form}>
          <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
            <WorksheetFormFields form={form} />
            
            <DialogFooter>
              <Button variant="outline" type="button" onClick={handleClose}>ยกเลิก</Button>
              <Button type="submit">บันทึก</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
